import React from "react";
import classes from "./TileList.module.scss";
import Tile from "../Tile";
import { tileTypes } from "../../../../utils/tileTypes";
import { tileSize } from "../../../../utils/tileSizes";
import StepTileList from "../StepTileList/StepTileList";

const TileList = ({
  data,
  type = tileTypes.DEFAULT,
  size = tileSize.DEFAULT,
  isStepTile = false,
  isOrTextPresent = false,
}) => {
  return !isStepTile ? (
    <div
      className={`${isOrTextPresent ? classes.orTile : classes.defaultTile} ${
        type === tileTypes.SMALL
          ? classes.tile_5_col
          : size === tileSize.EXTRA_SMALL
          ? classes.tile_6_col
          : size === tileSize.LARGE
          ? classes.tile_3_col
          : classes.tile_4_col
      }`}
    >
      {type === tileTypes.DEFAULT &&
        data?.map((item, index) => {
          if (!isOrTextPresent)
            return (
              <Tile
                key={item.key}
                value={item.value}
                label={item.label}
                stripeColor={item.color}
                size={size}
                type={type}
                smallTileIcon={item.icon}
                path={item.path}
                onClick={item.onClick}
                isHover={item.isHover}
                isVisible={item?.isVisible}
                name={item?.name}
                feature={item?.feature}
              />
            );
          else
            return (
              <React.Fragment key={item.key}>
                <Tile
                  key={item.key}
                  value={item.value}
                  label={item.label}
                  stripeColor={item.color}
                  size={size}
                  type={type}
                  smallTileIcon={item.icon}
                  path={item.path}
                  onClick={item.onClick}
                  isHover={item.isHover}
                  isVisible={item?.isVisible}
                  name={item?.name}
                  feature={item?.feature}
                />
                {parseInt(index) !== parseInt(data.length - 1) && (
                  <div className={classes.orDiv}>(OR)</div>
                )}
              </React.Fragment>
            );
        })}
      {type === tileTypes.DEFAULT_WITH_ICON &&
        data?.map((item) => {
          return (
            <Tile
              key={item.key}
              value={item.value}
              label={item.label}
              stripeColor={item.color}
              defaultTileicon={item.icon}
              size={size}
              type={type}
              path={item.path}
              onClick={item.onClick}
              isHover={item.isHover}
              isVisible={item?.isVisible}
              name={item?.name}
              feature={item?.feature}
            />
          );
        })}
      {type === tileTypes.SMALL &&
        data?.map((item) => {
          return (
            <Tile
              key={item.key}
              label={item.label}
              stripeColor={item.color}
              smallTileIcon={item.icon}
              size={size}
              type={type}
              onClick={item.onClick}
              path={item.path}
              isHover={item.isHover}
              isVisible={item?.isVisible}
              name={item?.name}
              feature={item?.feature}
            />
          );
        })}
    </div>
  ) : (
    <StepTileList data={data} size={size} type={type} />
  );
};

export default TileList;
